<template>
  <ODialog ref="dialog" hideWhenLoading>
    <v-card v-if="row != null">
      <ODialogBar title="Detalhe de FW Update" @close="dismiss" />

      <v-card-text class="d-flex flex-wrap pa-3 children-pa-3">
        <OCapCont class="oderon-col-4" label="ID">
          {{ row.id }}
        </OCapCont>

        <OCapCont class="oderon-col-4" label="Módulo">
          <router-link :to="`/clients/${row.clientId}`">{{
            row.clientId
          }}</router-link>
        </OCapCont>

        <OCapCont class="oderon-col-4" label="Veículo (atual)">
          {{ row.client.vehicleCode }}
        </OCapCont>

        <OCapCont class="oderon-col-12" label="Firmware">
          {{ row.firmware.version }} - {{ row.firmware.name }}
        </OCapCont>

        <OCapCont class="oderon-col-6" label="Criado">
          {{ row.createdAt }}
        </OCapCont>

        <OCapCont class="oderon-col-6" label="Atualizado">
          {{ row.updatedAt }}
        </OCapCont>

        <OCapCont class="oderon-col-6" label="Entregue">
          {{ row.deliveredAt || '─'}}
        </OCapCont>

        <OCapCont class="oderon-col-6" label="Removido/Cancelado">
          {{ row.deletedAt || '─'}}
        </OCapCont>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import { FWUpdate, Client, Firmware } from '@/models'

export default {
  data() {
    return {
      id: null,
      row: null,
      isLoading: false
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      let row = await FWUpdate.findById(this.id)
      row.client = await Client.findById(row.clientId)
      row.firmware = await Firmware.findById(row.firmwareId)
      this.row = row
    },

    dismiss() {
      return this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style></style>
